import { render, staticRenderFns } from "./PushNotificationPrompt.vue?vue&type=template&id=431b1b49&scoped=true"
import script from "./PushNotificationPrompt.vue?vue&type=script&lang=js"
export * from "./PushNotificationPrompt.vue?vue&type=script&lang=js"
import style0 from "./PushNotificationPrompt.vue?vue&type=style&index=0&id=431b1b49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431b1b49",
  null
  
)

export default component.exports